import { createContext, useState } from "react";
const UserContext = createContext({
    uid: null,
    data: null,
    questions: null,
    time: null,
    login: (uid) => { },
    loadData: (data) => { },
    logout: () => { },
    loadQuestions: (data) => { },
    loadTimer: (time) => { }
})
export const Provider = (props) => {
    const [uid, uidUpdater] = useState(null)
    const [time, timeUpdater] = useState(null)
    const [userData, userDataUpdater] = useState(null)
    const [questionData, questionDataUpdater] = useState(null)
    const login = (uid) => {
        uidUpdater(uid)
    }
    const loadData = (data) => {
        userDataUpdater(data)
    }
    const loadQuestions = (data) => {
        questionDataUpdater(data)
    }
    const loadTimer = (time) => {
        timeUpdater(time)
    }
    const logout = () => {
        uidUpdater(null)
        userDataUpdater(null)
        questionDataUpdater(null)
        timeUpdater(null)
    }
    return <UserContext.Provider value={{ uid, data: userData, questions: questionData, time, login, loadData, logout, loadQuestions, loadTimer }}>
        {props.children}
    </UserContext.Provider>
}
export default UserContext
